import React from 'react';
import SafeIcon from '../../common/SafeIcon';

const StatCard = ({ label, value, subtext }) => (
  <div className="bg-white border-4 border-retro-brown rounded-2xl p-6 shadow-retro-sm">
    <div className="font-display text-4xl text-retro-blue mb-1">{value}</div>
    <div className="font-body font-black text-xs uppercase tracking-widest text-retro-brown mb-2">{label}</div>
    <p className="font-body text-sm font-bold text-gray-500">{subtext}</p>
  </div>
);

const Demographics = () => {
  return (
    <section className="py-24 border-b-4 border-retro-brown bg-retro-cream">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="font-display text-5xl md:text-6xl uppercase tracking-tighter mb-6 leading-none">
              Exactly Where Your <br/>
              <span className="text-retro-teal">Guide Lands</span>
            </h2>
            <p className="font-body text-xl font-bold mb-8">
              We're not blasting a city. We're hand-picking homeowner routes inside high-value West Valley ZIP codes—so every guide lands in a home that can actually afford your service.
            </p>
            
            <div className="space-y-4 mb-8">
              <div className="flex items-center gap-4 bg-white border-2 border-retro-brown p-4 rounded-xl">
                <div className="w-12 h-12 bg-retro-yellow rounded-lg border-2 border-retro-brown flex items-center justify-center shrink-0">
                  <SafeIcon name="MapPin" className="text-xl" />
                </div>
                <p className="font-body font-bold">Covering Verrado, Estrella Mountain, Marley Park, and surrounding premium neighborhoods.</p>
              </div>
            </div>
            
            <div className="grid grid-cols-2 gap-4">
              <StatCard label="Homes Reached" value="10,000" subtext="Selected homeowner routes" />
              <StatCard label="Avg Household Income" value="$112k+" subtext="Well above metro average" />
              <StatCard label="Median Home Value" value="$525k+" subtext="Established, high-equity homes" />
              <StatCard label="Owner-Occupied" value="78%" subtext="Long-term residents, not renters" />
            </div>
          </div>
          
          <div className="relative">
            <div className="bg-retro-brown rounded-[2.5rem] p-4 shadow-retro rotate-1">
              <div className="bg-gray-200 rounded-[2rem] aspect-square overflow-hidden border-4 border-retro-brown flex items-center justify-center relative">
                <div className="absolute inset-0 opacity-20 bg-[url('https://images.unsplash.com/photo-1582159328034-ad01552661d2?auto=format&fit=crop&q=80')] bg-cover"></div>
                <div className="relative z-10 text-center p-8">
                   <div className="inline-block bg-retro-yellow text-retro-brown font-display px-6 py-2 rounded-full border-2 border-retro-brown mb-4 uppercase">Target Area: West Valley</div>
                   <p className="font-body font-black text-retro-brown text-lg">Targeting high-intent <br/>homeowner routes in <br/>Buckeye, Goodyear, & Surprise</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Demographics;